import React, { useEffect } from "react";
import { connect } from "react-redux";
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import { cardStyle } from "../../../Dashboard/customStyles";
import { generateAssumptions } from "../../../../store/modules/waterfall/actions";
import { primary } from "../../../../assets/colorPallet";
import CurrencyFormatter from "currency-formatter";

function OtherKeyMetrics({
  dealType,
  assumptions,
  dispatchGenerateAssumptions,
}) {
  // Mounted
  useEffect(() => {
    dispatchGenerateAssumptions(dealType);
  }, []);

  return (
    <div>
      {assumptions && (
          <div className="flex flex-wrap justify-center">

            <Card sx={cardStyle.dealCard}>
              <CardHeader
                sx={{ background: primary }}
                titleTypographyProps={{ fontSize: 40, fontWeight: 700, color: "white", textAlign: "center" }}
                title="Other Key Metrics"
              />
              <CardContent sx={{ padding: "30px 30px", height: "350px" }}>
                <div className="flex justify-between items-center my-7 px-5">
                  <div className="items-center text-lg">GP Promote</div>
                  <div className="items-center text-lg">{CurrencyFormatter.format(assumptions.scheduleEngine.GPPromote, { code: "USD" })}</div>
                </div>
                <div className="flex justify-between items-center my-7 px-5">
                  <div className="items-center text-lg">Basis for Return Calculations</div>
                  <div className="items-center text-lg">
                    {assumptions.basis === "IRR" ? "IRR" : (assumptions.basis === "COC" ? "Cash on Cash" : "Multiple")}
                  </div>
                </div>
                <div className="flex justify-between items-center my-7 px-5">
                  <div className="items-center text-lg">Proceeds Distributed</div>
                  <div className="items-center text-lg">{assumptions.proceeds === "PR" ? "Pro Rata" : "Per Preference Schedule"}</div>
                </div>
              </CardContent>
            </Card>

          </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  assumptions: state.waterfall.assumptions,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateAssumptions(dealType) {
    await dispatch(generateAssumptions(dealType));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OtherKeyMetrics);
